
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecom/orders",
      function () {
        return require("private-next-pages/ecom/orders.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecom/orders"])
      });
    }
  